// useDocumentMeta — runtime updater for <title> and Open Graph meta tags.
// Many modern link-preview crawlers (WhatsApp, iMessage, Slack, Discord, Twitter
// card validator) execute JS before snapshotting the page, so updating these
// tags inside React works for them. Static fallback tags in /public/index.html
// cover the rest.
import { useEffect } from "react";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

export default function useDocumentMeta({ title, description, image, url, imageWidth, imageHeight }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', { name: "description", content: description });
    }
    if (title) {
      upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
      upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    }
    if (description) {
      upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
      upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    }
    if (image) {
      upsertMeta('meta[property="og:image"]', { property: "og:image", content: image });
      upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: image });
      if (imageWidth)  upsertMeta('meta[property="og:image:width"]',  { property: "og:image:width",  content: String(imageWidth) });
      if (imageHeight) upsertMeta('meta[property="og:image:height"]', { property: "og:image:height", content: String(imageHeight) });
    }
    if (url) {
      upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
    }
  }, [title, description, image, url, imageWidth, imageHeight]);
}
